import { Group, Paper, Stack, Text } from "@mantine/core"
import React from "react"
import styled from "styled-components"
import { Value } from "../scaffold/Value"
import { ViewValueType } from "src/state/_types"

type ObjectCardItemProps = {
    label: string
    value: string | number | undefined | null
    color?: string
    border?: boolean
    type: ViewValueType
    element?: React.ReactNode
    relation_field?: string | null
    relation?: {
        [key: string]: string | number | boolean | null | undefined;
    }
}

export function ObjectCardItem({ label, value, color = 'var(--mantine-color-text-primary-6)', border = false, type, element, relation_field = null, relation }: ObjectCardItemProps) {
    return (
        <Stack gap={0}>
            <Text fw={100} size="xs" component="span" lh="1.1rem" c="var(--mantine-color-dark-2)">{label}</Text>
            <Text
                fw={600}
                size="sm"
                component="span"
                lh="1.2rem"
                c={color}
                style={{
                    border: border ? '1px dashed var(--mantine-color-gray-2)': 'none',
                    borderRadius: border ? '4px': '0',
                    padding: border ? '2px 4px 1px 3px': '0',
                    //background: border ? 'var(--mantine-color-gray-1)': 'initial',
                }}
            >
                {element ? (
                    <>
                        {element}
                    </>
                ) : <Value type={type} value={value} relation_field={relation_field} relation={relation} />}
            </Text>
        </Stack>
    )
}

export function ObjectCardItemSlim({ label, value, color = 'var(--mantine-color-text-primary-6)', border = false, type, element, relation_field = null }: ObjectCardItemProps) {
    return (
        <Group gap={2}>
            <Text fw={100} size="xs" component="span" lh="1.1rem" c="var(--mantine-color-dark-2)">{label}</Text>
            <Text
                fw={600}
                size="xs"
                component="span"
                lh="1.2rem"
                c={color}
                style={{
                    border: border ? '1px dashed var(--mantine-color-gray-2)': 'none',
                    borderRadius: border ? '4px': '0',
                    padding: border ? '2px 4px 1px 3px': '0',
                    //background: border ? 'var(--mantine-color-gray-1)': 'initial',
                }}
            >
                {element ? (
                    <>
                        {element}
                    </>
                ) : <Value type={type} value={value} relation_field={relation_field} />}
            </Text>
        </Group>
    )
}

type ObjectCardProps = React.PropsWithChildren<{
    cols?: number
}>

const ObjectCardItemsWrapper = styled.div<{ cols?: number }>`
    /* display: grid;
    grid-template-columns: repeat(${props => props.cols || "1"}, 1fr);
    grid-gap: 1rem; */
    display: flex;
    justify-content: space-between;
`

export function ObjectCard({
    children,
    cols = 1
}: ObjectCardProps) {
    return (
        <Paper my="xs" p="sm" withBorder shadow="xs">
            <ObjectCardItemsWrapper cols={cols}>
                {children}
            </ObjectCardItemsWrapper>
        </Paper>
    )
}